import { Controller } from '@hotwired/stimulus'

import BigPicture from 'bigpicture'

export default class extends Controller {
  static values = {
    service: String
  }

  static targets = [
    "body",
    "content"
  ]

  connect() {
    // Early return if no content target exists
    if (!this.hasContentTarget) return

    // Store original content before any processing
    this.originalContent = this.contentTarget.innerHTML

    if (this.serviceValue === "default") {
      this.transformHashtags()
      this.highlightUsernames()
    }

    this.assignEventToImage()

    if (['default', 'poll'].includes(this.serviceValue)) {
      setTimeout(() => this.removeFreshClass(), 500)
    }
  }

  disconnect() {
    // Store original content before processing if we haven't already
    if (!this.originalContent) return

    // Restore original content
    this.contentTarget.innerHTML = this.originalContent
  }

  assignEventToImage() {
    if (!this.element.querySelector('.text > img')) { return }

    this.contentTarget.querySelectorAll('.text > img').forEach((el) => {
      el.onclick = () => {
        BigPicture({
          el: el,
          imgSrc: el.src
        })
      }
    })
  }

  removeFreshClass() {
    this.bodyTarget.classList.remove("fresh")
  }

  transformHashtags() {
    // Regular expression to match hashtags
    const hashtagRegex = /#[\w\u0080-\uFFFF]+/g

    const currentContent = this.contentTarget.innerHTML

    // Replace hashtags with links
    this.contentTarget.innerHTML = currentContent.replace(hashtagRegex, (hashtag) => {
      const encodedHashtag = encodeURIComponent(hashtag)
      return `<a data-turbo-frame="_top" href="/search?q=${encodedHashtag}">${hashtag}</a>`
    })
  }

  highlightUsernames() {
    // Match usernames that follow validation pattern: start/end with alphanumeric, allow dots/underscores/hyphens in middle
    const usernameRegex = /(^|[^\wА-Яа-я])@([А-Яа-яA-Za-z0-9]([А-Яа-яA-Za-z0-9\-\_\.]*[А-Яа-яA-Za-z0-9])?)/g

    const currentContent = this.contentTarget.innerHTML

    this.contentTarget.innerHTML = currentContent.replace(usernameRegex, (match, prefix, username) => {
      const encodedUsername = encodeURIComponent(username)
      return `${prefix}<a data-turbo-frame="_top" href="/@${encodedUsername}">@${username}</a>`
    })
  }
}
